const doc = [({"da":({"js":({"admin":({"teams":({"show":({"add_user":"Tilføj bruger", "the_team_was_deleted":"Holdet blev slettet", "team_members":"Holdmedlemmer:"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;